import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowNextSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.707 5.293 6 2 9.293l.707.707 4-4-4-4L2 2.707Zm3.293 0L8.586 6 5.292 9.293 6 10l4-4-4-4-.707.707Z"
    />
  </svg>
);
export default IconArrowNextSizeXs;
